var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app--picture-drawn pl-3"},[(_vm.animalDrawn[0])?_c('img',{class:{
			'horse-head': _vm.animalDrawn[0].name === 'H',
			'giraffe-head': _vm.animalDrawn[0].name==='Gir',			
			'duck-head': _vm.animalDrawn[0].name==='D'
		},attrs:{"src":_vm.animalDrawn[0].src,"alt":""}}):_vm._e(),(_vm.animalDrawn[1])?_c('img',{class:{
			'giraffe-body': _vm.animalDrawn[1].name === 'a'
		},attrs:{"src":_vm.animalDrawn[1].src,"alt":""}}):_vm._e(),(_vm.animalDrawn[2])?_c('img',{class:{
			'giraffe-leg': _vm.animalDrawn[2].name === 'ffe',
			'horse-leg': _vm.animalDrawn[2].name === 'se'
		},attrs:{"src":_vm.animalDrawn[2].src,"alt":""}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }